import React, {useState} from "react"
import {useDispatch} from "react-redux"

import SRModal from "../../../components/modal/modal"
import {removeMember} from "../../../redux/group/groupAction";

const RemoveMemberModal = ({member}) => {
    const dispatch = useDispatch()
    const [modalIsOpen, setModalIsOpen] = useState(true)

    const onOpenModal = () => {
        setModalIsOpen(true)
    }

    const onCloseModal = () => {
        setModalIsOpen(false)
    }

    const onYes = () => {
        dispatch(removeMember(member))
        onCloseModal()
    }

    const onNo = () => {
        onCloseModal()
    }

    return (
        <SRModal text={"Remove"}
                 title={"Remove a member"}
                 className={"removeMember addMember"}
                 onOpen={onOpenModal}
                 onClose={onCloseModal}
                 isOpen={modalIsOpen}>
            <button onClick={onYes} className={"btn btn-sm btn-success"}>Yes</button>
            <button onClick={onNo} className={"btn btn-sm btn-warning float-right"}>No</button>
        </SRModal>
    )
}

export default RemoveMemberModal
